import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["toggleIcon", "sectionContent"]

    connect() {
        this.startAutoRefresh()
    }

    disconnect() {
        this.stopAutoRefresh()
    }

    startAutoRefresh() {
        const interval = this.data.get("autoRefresh")
        if (interval && parseInt(interval) > 0) {
            this.refreshTimer = setInterval(() => {
                this.refreshData()
            }, parseInt(interval))
        }
    }

    stopAutoRefresh() {
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer)
            this.refreshTimer = null
        }
    }

    toggleSection(event) {
        const section = event.currentTarget.dataset.section
        const content = this.sectionContentTargets.find(el => el.dataset.section === section)
        const right = event.currentTarget.querySelector('.js-insight-chevron-right')
        const down = event.currentTarget.querySelector('.js-insight-chevron-down')

        if (content && content.classList.contains('hidden')) {
            content.classList.remove('hidden')
            if (right) right.classList.add('hidden')
            if (down) down.classList.remove('hidden')
        } else if (content) {
            content.classList.add('hidden')
            if (right) right.classList.remove('hidden')
            if (down) down.classList.add('hidden')
        }
    }

    toggleComponent(event) {

    }

    refreshData() {
        window.location.reload()
    }
}